import React from 'react'
import { Text } from 'react-native'
import { MainColors } from '../constants/Colors'
const ValidationErrorMessage =  ({message}) => {
    return <Text style={{
        textAlign: 'center',
        color: MainColors.danger,
        margin: 10,
        fontWeight: '500',
    }}>{message}</Text>
}

export default ValidationErrorMessage